import { ChangeLogType } from './constants';

export default {
  props: {
    revertAll: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      diffs: {},
    };
  },
  watch: {
    revertAll(current, prev) {
      if (!prev && current) {
        this.onRevertAll();
      }
    },
  },
  computed: {
    hasDiffs() {
      return Object.values(this.diffs).some(Boolean);
    },
  },
  methods: {
    onChange({ name, data, path, hasDiff, ignore }: ChangeLogType) {
      this.diffs = {
        ...this.diffs,
        [name]: hasDiff,
      };

      this.$emit('onCourseSettingsChanged', {
        name,
        hasDiff,
        data,
        ignore,
        path,
      });
    },
    onRevertAll() {
      this.resetChanges();
      this.diffs = {};
      this.$emit('onRevertAllHandled');
    },
  },
};
